import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import PhotoGrid from "@/components/PhotoGrid";
import { pub, client, errMsg } from "@/lib/api";

export default function PhotosTab() {
  const qc = useQueryClient();
  const { data: photos = [] } = useQuery({ queryKey: ["photos"], queryFn: () => pub.get("/photos").then((r) => r.data) });
  const remove = async (p) => {
    if (!window.confirm("Delete this photo for everyone?")) return;
    try { await client("admin").delete(`/photos/${p.id}`); toast.success("Photo deleted"); qc.invalidateQueries({ queryKey: ["photos"] }); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-6">
      <h2 className="text-3xl font-bold text-amber-950">Photos <span className="text-stone-500 text-2xl">({photos.length})</span></h2>
      <p className="text-stone-700">Photos appear right away. Delete anything that shouldn't be there. To upload as an organizer, use the public Photos page while signed in.</p>
      <PhotoGrid photos={photos} canDelete={() => true} onDelete={remove} />
    </div>
  );
}
